import React, {Component, Fragment} from 'react';
import '../resources/stylesheets/genericBanners.css';
import {NoInfo} from "./structure/NoInfo";


class GenericBanners extends Component {

  constructor(props) {
    super(props);
    this.state = {
      urlLang: "es"
    }
  }

  handleLanguageChange(e) {
    this.setState({urlLang: e.value, copied: {}});
  }


  render(){

    const { genericBanners, handleGenericBannerClick } = this.props;
    const { urlLang } = this.state;
    const bannerHTML = [];

    if(genericBanners && genericBanners.length > 0){
      genericBanners.forEach((gb,i) => {

        const itemResource = JSON.parse(gb.itemResource);
        const imgSrc = itemResource[urlLang];
        const itemLinkedUrl = JSON.parse(gb.itemLinkedUrl);
        //const href = itemLinkedUrl[urlLang];

        bannerHTML.push(
          <li className="genericBannerItem" key={i} onClick={() => handleGenericBannerClick(itemResource,itemLinkedUrl)}>
            <img src={imgSrc} className="bannerImg" alt=""/>
            <p className="bannerName">{gb.itemName}</p>
            <button className="btn linkButtons">
              <span className="glyphicon glyphicon-film"></span>
              <span>Preview</span>
            </button>
          </li>
        );
      });
    }

    return (
      bannerHTML.length > 0 ?
        <Fragment>
          <ul className="genericBannerList">{bannerHTML}</ul>
        </Fragment>
        :
        <Fragment>
          <NoInfo displayMsg="There are no generic banners available at this time"/>
        </Fragment>
    )
  };

}

export default GenericBanners;
